/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

export const TeamAddIcon = () => {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect y="0.5" width="24" height="24" rx="12" fill="#F1F2F4" />
			<rect width="16" height="16" transform="translate(4 4.5)" fill="white" fillOpacity="0.01" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6667 11.8333V9.16667C12.6667 8.98986 12.5964 8.82029 12.4714 8.69526C12.3464 8.57024 12.1768 8.5 12 8.5C11.8232 8.5 11.6536 8.57024 11.5286 8.69526C11.4036 8.82029 11.3333 8.98986 11.3333 9.16667V11.8333H8.66667C8.48986 11.8333 8.32029 11.9036 8.19526 12.0286C8.07024 12.1536 8 12.3232 8 12.5C8 12.6768 8.07024 12.8464 8.19526 12.9714C8.32029 13.0964 8.48986 13.1667 8.66667 13.1667H11.3333V15.8333C11.3333 16.0101 11.4036 16.1797 11.5286 16.3047C11.6536 16.4298 11.8232 16.5 12 16.5C12.1768 16.5 12.3464 16.4298 12.4714 16.3047C12.5964 16.1797 12.6667 16.0101 12.6667 15.8333V13.1667H15.3333C15.5101 13.1667 15.6797 13.0964 15.8047 12.9714C15.9298 12.8464 16 12.6768 16 12.5C16 12.3232 15.9298 12.1536 15.8047 12.0286C15.6797 11.9036 15.5101 11.8333 15.3333 11.8333H12.6667Z"
				fill="#42526E"
			/>
		</svg>
	);
};
